<ng-container *ngIf="compact; else fullLayout">
    <mat-form-field
        [appearance]="appearance"
        [floatLabel]="floatLabel"
        [subscriptSizing]="'dynamic'"
        class="phone-field__unified w-full"
    >
        <mat-label>{{ label | autoTranslate }}</mat-label>
        <span matPrefix class="phone-field__ddi-prefix">
            <span class="phone-field__ddi-visual" aria-hidden="true">
                <span class="phone-field__ddi-flag" *ngIf="selectedCountryFlag">{{ selectedCountryFlag }}</span>
                <span class="phone-field__ddi-code">{{ ddiControl.value || defaultCountryCode }}</span>
                <mat-icon class="phone-field__ddi-chevron">expand_more</mat-icon>
            </span>

            <mat-select
                #ddiSelect
                class="phone-field__ddi-select-hit"
                [formControl]="ddiControl"
                [panelClass]="ddiPanelClass"
                disableOptionCentering
                (opened)="onDdiPanelOpened()"
            >
                <mat-select-trigger>
                    <span class="phone-field__ddi-hit-target">&nbsp;</span>
                </mat-select-trigger>

                <div class="phone-field__search" (click)="onDdiSearchClick($event)" (mousedown)="$event.stopPropagation()">
                    <mat-icon class="phone-field__search-icon">search</mat-icon>
                    <input
                        #ddiSearchInput
                        class="phone-field__search-input"
                        type="text"
                        [value]="ddiSearchTerm"
                        [placeholder]="'Buscar país ou DDI' | autoTranslate"
                        (input)="onDdiSearchInput($event)"
                        (keydown)="onDdiSearchKeydown($event)"
                        (click)="onDdiSearchClick($event)"
                    />
                </div>

                <mat-option *ngIf="filteredCountryCodeOptions.length === 0" [disabled]="true">
                    <span autoTranslate>Nenhum resultado</span>
                </mat-option>

                <mat-option *ngFor="let opt of filteredCountryCodeOptions" [value]="opt.value">
                    <span class="phone-field__option">
                        <span class="phone-field__option-flag" aria-hidden="true">{{ flagEmoji(opt) }}</span>
                        <span class="phone-field__option-label">{{ opt.label }}</span>
                    </span>
                </mat-option>
            </mat-select>
        </span>

        <input
            matInput
            type="text"
            class="phone-field__number-input"
            [formControl]="phoneControl"
            [placeholder]="phonePlaceholder | autoTranslate"
            [mask]="phoneMask"
            autocomplete="tel-national"
            (mousedown)="onPhoneInputInteract($event)"
            (click)="onPhoneInputInteract($event)"
        />

        <mat-error *ngIf="required && phoneControl.touched && phoneControl.hasError('required')" autoTranslate>
            Campo Obrigatório
        </mat-error>
    </mat-form-field>
</ng-container>

<ng-template #fullLayout>
    <div class="phone-field">
        <mat-form-field [appearance]="appearance" [subscriptSizing]="'dynamic'" class="w-full phone-field__ddi">
            <mat-label autoTranslate>DDI</mat-label>
            <mat-select
                #ddiSelect
                [formControl]="ddiControl"
                [panelClass]="ddiPanelClass"
                disableOptionCentering
                (opened)="onDdiPanelOpened()"
            >
                <mat-select-trigger>
                    <span class="phone-field__ddi-trigger">
                        <span class="phone-field__ddi-flag" *ngIf="selectedCountryFlag">{{ selectedCountryFlag }}</span>
                        <span>{{ ddiControl.value || defaultCountryCode }}</span>
                    </span>
                </mat-select-trigger>

                <div class="phone-field__search" (click)="onDdiSearchClick($event)" (mousedown)="$event.stopPropagation()">
                    <mat-icon class="phone-field__search-icon">search</mat-icon>
                    <input
                        #ddiSearchInput
                        class="phone-field__search-input"
                        type="text"
                        [value]="ddiSearchTerm"
                        [placeholder]="'Buscar país ou DDI' | autoTranslate"
                        (input)="onDdiSearchInput($event)"
                        (keydown)="onDdiSearchKeydown($event)"
                        (click)="onDdiSearchClick($event)"
                    />
                </div>

                <mat-option *ngIf="filteredCountryCodeOptions.length === 0" [disabled]="true">
                    <span autoTranslate>Nenhum resultado</span>
                </mat-option>

                <mat-option *ngFor="let opt of filteredCountryCodeOptions" [value]="opt.value">
                    <span class="phone-field__option">
                        <span class="phone-field__option-flag" aria-hidden="true">{{ flagEmoji(opt) }}</span>
                        <span class="phone-field__option-label">{{ opt.label }}</span>
                    </span>
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field [appearance]="appearance" [subscriptSizing]="'dynamic'" class="w-full phone-field__number">
            <mat-label>{{ label | autoTranslate }}</mat-label>
            <input
                matInput
                type="text"
                class="phone-field__number-input"
                [formControl]="phoneControl"
                [placeholder]="phonePlaceholder | autoTranslate"
                [mask]="phoneMask"
                autocomplete="tel-national"
            />
            <button
                *ngIf="whatsappControl"
                type="button"
                mat-icon-button
                matSuffix
                class="phone-field__whatsapp-toggle"
                [class.phone-field__whatsapp-toggle--active]="isWhatsapp"
                (click)="toggleWhatsapp()"
                [matTooltip]="(isWhatsapp ? 'É WhatsApp' : 'Marcar como WhatsApp') | autoTranslate"
            >
                <img src="assets/icons/social-networks/whatsapp.png" alt="WhatsApp" class="w-5 h-5" />
            </button>
            <mat-error *ngIf="required && phoneControl.touched && phoneControl.hasError('required')" autoTranslate>
                Campo Obrigatório
            </mat-error>
        </mat-form-field>
    </div>
</ng-template>
